var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo, useCallback, useEffect } from 'react';
import { useField, useFormikContext } from 'formik';
import { useFormField } from '../../hooks';
import { useErrorTrackingOnSubmit } from '../hooks';
import Input from '../../../input';
import FormInput from '../form-input';
import theme from '../../../../theme';
var EmailInput = function (_a) {
    var label = _a.label, subtext = _a.subtext, tooltip = _a.tooltip, trackValidationOnBlur = _a.trackValidationOnBlur, trackValidationOnSubmit = _a.trackValidationOnSubmit, doCustomValidation = _a.doCustomValidation, restProps = __rest(_a, ["label", "subtext", "tooltip", "trackValidationOnBlur", "trackValidationOnSubmit", "doCustomValidation"]);
    var field = useField(restProps)[0];
    var _b = useFormikContext(), validateOnChange = _b.validateOnChange, validateOnBlur = _b.validateOnBlur;
    var onBlur = field.onBlur, onChange = field.onChange, name = field.name;
    var disabled = restProps.disabled;
    var _c = useFormField(name), value = _c.value, error = _c.error, touched = _c.touched, customError = _c.customError, customWarning = _c.customWarning, setCustomError = _c.setCustomError, setCustomWarning = _c.setCustomWarning, setError = _c.setError, validateField = _c.validateField;
    useErrorTrackingOnSubmit(name, trackValidationOnSubmit);
    var _handleBlur = useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var value, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    value = event.target.value;
                    // We can propagate on blur event here only if we also validate on change, which we are - so it's fine.
                    // Otherwise we would need to stop the execution after validation here.
                    onBlur(event);
                    errorMessage = error || customError;
                    if (!!validateOnBlur) return [3 /*break*/, 3];
                    if (!(value && value.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, validateField(value)];
                case 1:
                    errorMessage = _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    setError();
                    _a.label = 3;
                case 3:
                    // Run custom validation only if value is present. If value is not present, then we don't run
                    // validation on our own. Once validation is active for the entire form, then `onBlur` itself will run
                    // the validation and our validation will still hold.
                    if (!errorMessage && value && value.length > 0) {
                        doCustomValidation &&
                            doCustomValidation({ setCustomError: setCustomError, setCustomWarning: setCustomWarning, value: value, name: name, remove: false });
                    }
                    trackValidationOnBlur && trackValidationOnBlur({ name: name, value: value, error: errorMessage });
                    return [2 /*return*/];
            }
        });
    }); }, [
        onBlur,
        error,
        customError,
        validateOnBlur,
        name,
        validateField,
        setError,
        doCustomValidation,
        setCustomError,
        setCustomWarning,
        trackValidationOnBlur,
    ]);
    var _handleChange = useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var value;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Remove custom errors and warnings set by us.
                    setCustomError();
                    setCustomWarning();
                    value = event.target.value;
                    onChange(event);
                    doCustomValidation && doCustomValidation({ setCustomError: setCustomError, setCustomWarning: setCustomWarning, value: value, name: name, remove: true });
                    if (!!validateOnChange) return [3 /*break*/, 3];
                    if (!(value && value.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, validateField(value)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    setError();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [
        setCustomError,
        setCustomWarning,
        onChange,
        doCustomValidation,
        name,
        validateOnChange,
        validateField,
        setError,
    ]);
    useEffect(function () {
        if (disabled && value.length > 0) {
            doCustomValidation && doCustomValidation({ setCustomError: setCustomError, setCustomWarning: setCustomWarning, value: value, name: name, remove: false });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled, value]);
    return (React.createElement(FormInput, { label: label, subtext: subtext, tooltip: tooltip, name: name, error: error || customError, warning: customWarning, touched: disabled || touched },
        React.createElement(Input, __assign({}, field, restProps, { type: "email", error: error || customError, warning: customWarning, touched: disabled || touched, onBlur: _handleBlur, onChange: _handleChange, padding: theme.spacing.small }))));
};
export default memo(EmailInput);
